import { deserialize } from "cerialize";

export class UserPermissions {

  @deserialize
  readable: boolean;

  @deserialize
  updatable: boolean;

  @deserialize
  deletable: boolean;

}
